import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Lock } from "lucide-react";
import { fmtDate } from "./NextUp";

const OPTIONS = [
  { value: "available", label: "In", active: "border-emerald-500 bg-emerald-500 text-white" },
  { value: "maybe", label: "Maybe", active: "border-amber-400 bg-amber-400 text-amber-950" },
  { value: "out", label: "Out", active: "border-rose-500 bg-rose-500 text-white" },
];

export function PlayerSheet({ player, weeks, availability, isCaptain, onClose, onSet }) {
  return (
    <Dialog open={Boolean(player)} onOpenChange={(v) => !v && onClose()}>
      <DialogContent aria-describedby={undefined} className="max-h-[85vh] overflow-y-auto border-slate-200 bg-white text-slate-900" data-testid="player-sheet">
        <DialogHeader>
          <DialogTitle className="font-display text-xl uppercase tracking-wide">
            {player?.name}
            {isCaptain && (
              <span className="ml-2 text-xs font-normal normal-case text-slate-500" data-testid="player-sheet-stats">
                GP {player?.gp ?? 0} · AV {player?.ga ?? 0}
              </span>
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          {weeks.map((w) => {
            const status = availability[`${player?.id}:${w.id}`] || "";
            const disabled = w.locked && !isCaptain;
            return (
              <div key={w.id} className={`rounded-lg border border-slate-200 p-2.5 ${disabled ? "opacity-50" : ""}`} data-testid={`player-sheet-week-${w.id}`}>
                <div className="flex items-center justify-between gap-2">
                  <div className="min-w-0">
                    <p className="flex items-center gap-1 text-xs font-semibold text-slate-800">
                      {w.locked && <Lock className="h-3 w-3 text-slate-400" />}
                      {fmtDate(w.date)}
                      {w.time ? ` · ${w.time}` : ""}
                    </p>
                    <p className="truncate text-[11px] text-orange-600">
                      {w.opponent || "—"}
                      {w.location ? ` @ ${w.location}` : ""}
                    </p>
                  </div>
                  <div className="flex shrink-0 gap-1">
                    {OPTIONS.map((o) => (
                      <button
                        key={o.value}
                        data-testid={`sheet-status-${w.id}-${o.value}`}
                        disabled={disabled}
                        onClick={() => player && onSet(player.id, w.id, status === o.value ? "" : o.value)}
                        className={`rounded-md border px-2 py-1 text-[11px] font-semibold transition-colors ${
                          status === o.value ? o.active : "border-slate-200 bg-slate-50 text-slate-500 hover:border-orange-300"
                        }`}
                      >
                        {o.label}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
          {weeks.length === 0 && <p className="py-6 text-center text-sm text-slate-500">No games scheduled yet.</p>}
        </div>
        <p className="text-[10px] text-slate-400">Tap your active status again to clear it.</p>
      </DialogContent>
    </Dialog>
  );
}
